/**
 * React error boundary that logs errors to Firebase.
 */
import React, { Component, ErrorInfo } from "react";

import { FirebaseContext } from "../../../context/FirebaseContext/FirebaseContext";
import { currentDateDataBase,getTime } from "../../../configurations/Helpers/Dateshelper";
import { logDb } from "../../../configurations/DataBase/bases";
import { createDocument } from "../../../configurations/DataBase/crud";
import { isProduction } from "../../../configurations/Axios/Clients";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static contextType = FirebaseContext;
  declare context: React.ContextType<typeof FirebaseContext>;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    error;
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const path = isProduction()?"Production":"Sandbox"
    console.error("ErrorBoundary caught an error", error, errorInfo);
    const errorData = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
    };
    createDocument(errorData,logDb).catch((err) =>
      console.error("Error al registrar el log localmente:", err)
    );
    if (this.context && this.context.firebaserealtime) {
      this.context.firebaserealtime
        .pushData("Logs/"+path+"/Front/"+currentDateDataBase()+"/"+getTime(), errorData)
        .catch((err: any) =>
          console.error("Error al registrar en Firebase:", err)
        );
    }
  }

  render() {
    if (this.state.hasError) {
      
      window.location.href = "/";
      return null; 
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
